import { ProgramaVerificacionViewModel } from '../../../../_campanias/programasverificacion/datosbasicos/pvcam-datosbasicos.types';

export class DatosCaPeriodoCamViewModel {
    constructor() {}

    public Id: number;
    public IdPeriodo: number;
    public IdCampaniaDescripcion: string;
    public DescripcionPeriodo: string;
    public IdCa: number;
    public IdUsuario: number;
    public EntidadAuditora: boolean;
    public ProgramaVerificacion: boolean;
    public ComunidadAutonoma: string;
    public NombreUsuario: string;
    public ApellidosUsuario: string;
    public IdCampania: number;
    public IdUsuarioDefaultAceptacion: number | null;
    public IdUsuarioDefaultUnidadInspeccion: number | null;
    public IdUsuarioDefaultAforoCorte: number | null;
    public PresentacionAutoEnabled: boolean;
    public CicloCortoEnabled: boolean;
    public TPeriodoEntidadAuditoraCamCollection: PeriodoEntidadAuditoraCamViewModel[];
}

export class ListaDatosCaPeriodoViewModel {
    public IdCampaniaDescripcion: string;
    public DescripcionPeriodo: string;
    public PeriodoFechaInicio?: Date;
    public PeriodoFechaFin?: Date;
    public DatosCaPeriodoCollection: DatosCaPeriodoCamViewModel[];
}

export class PeriodoEntidadAuditoraCamViewModel {
    public Id: number;
    public IdPeriodoDatosCa: number;
    public IdEntidadAuditora: number;
    public RazonSocialEa: string;
    public NifEa: string;
    public ProvinciaEa: string;
    public LocalidadEa: string;
    public TwProgramaVerificacionCam: ProgramaVerificacionViewModel;
}
